import { ResponseModel, handleGetAsync, handlePostAsync, handlePutAsync, handleDeleteAsync } from "../../components/common/commonclass";
import { EndPoint } from "../../components/common/config";
import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../../components/common/notification/toaster_notify.component";

var responseModel = new ResponseModel();

export class UserServices {

    static async login(email, userPassword) {
        try {
            const requestURL = `${EndPoint.USERS}/login`; //endpoint
            const model = { email, userPassword };
            const responseModel = await handlePostAsync(requestURL, false, model);
            return responseModel;
        } catch (error) {
            console.error("Login error in service:", error);
            return null;
        }
    }

    static async getAllUsers() {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.USERS; //endpoint
        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        }
        else {
            console.error('Failed to fetch Users.');
            return [];
        }
    }

    // Create
    static async addNewUser(data) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.USERS; // endpoint

        responseModel = await handlePostAsync(requestURL, true, data);

        if (responseModel) {
            handleNotify('Users added successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to create new Users.');
        }
    }

    // Get by ID
    static async getUserById(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.USERS}/${id}`; // endpoint

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        } else {
            throw new Error('Failed to fetch User by ID');
        }
    }

    // Update 
    static async updateUserById(id, data) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.USERS}/${id}`; // endpoint

        responseModel = await handlePutAsync(requestURL, true, data);
        if (responseModel) {
            handleNotify('Users updated successfully.', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to update Users.');
        }
    }


    // Delete 
    static async deleteUser(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.USERS}/${id}`; // endpoint

        try {
            responseModel = await handleDeleteAsync(requestURL, true);
            if (responseModel) {
                return responseModel;
            } else {
                throw new Error('Failed to delete Users data.');
            }
        } catch (error) {
            console.error('Error deleting Users data:', error);
            throw error;
        }
    }

    // Delete  by IDs
    static async deleteManyUsers(ids) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.USERS}/deletemany`; // endpoint

        responseModel = await handleDeleteAsync(requestURL, true, ids);
        if (responseModel) {
            handleNotify(responseModel, TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            handleNotify(responseModel.error, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
        }
    }
}
